export default "__VITE_ASSET__CGA0LtzO__"